import { pick } from "lodash";
import {
  CreateTransactionsObject,
  CreateTransactionsPayload,
  TRANSACTION_TYPE_MAP,
  TransactionTypeOptions,
} from "../../pages/Transactions/panels/transactions/types";
import { toOptionalNumber } from "../../utils/cashback";
import { hasNumericTaxWithheld } from "../../utils/taxWithheld";
import { TransactionsServerResponse } from "./types";

export const transformTransactionsResponse = (
  response: TransactionsServerResponse,
) => {
  let data = {
    pagination: response.pagination,
    transactions: response.result,
  };

  return data;
};

export const transformTransactionPayload = (
  transaction: CreateTransactionsObject,
): CreateTransactionsPayload => {
  // Picks rather than omits: the API rejects any field TransactionDTO does not declare.
  let payload: any = {
    ...pick(transaction, ["note", "transactionDate"]),
    transactionType: TRANSACTION_TYPE_MAP[transaction.transactionType.value],
    amount: Number.parseFloat(transaction.amount),
  };

  if (transaction.fromAccount) {
    payload.fromAccountId = Number(transaction.fromAccount.value);
  } else {
    payload.fromAccountId = undefined;
  }

  if (transaction.toAccount) {
    payload.toAccountId = Number(transaction.toAccount.value);
  } else {
    payload.toAccountId = undefined;
  }

  if (transaction.subCategory) {
    payload.subCategoryId = Number(transaction.subCategory.value);
  } else {
    payload.subCategoryId = undefined;
  }

  if (transaction.category) {
    payload.categoryId = Number(transaction.category.value);
  } else {
    payload.categoryId = undefined;
  }

  const isIncome =
    transaction.transactionType.value === TransactionTypeOptions.INCOME;
  const hasTaxWithheld = hasNumericTaxWithheld(transaction.taxWithheld);
  // With a tax, the amount field holds the gross; sending only gross + tax lets the API derive the net.
  if (isIncome && hasTaxWithheld) {
    payload.grossAmount = payload.amount;
    payload.taxWithheld = Number(transaction.taxWithheld);
    delete payload.amount;
  } else if (isIncome && transaction.taxWithheld === null) {
    payload.taxWithheld = null;
  }

  if (!transaction.isRecurring) {
    if (
      transaction.transactionType.value === TransactionTypeOptions.EXPENSE &&
      transaction.cashbackEarned !== undefined
    ) {
      payload.cashbackEarned = toOptionalNumber(transaction.cashbackEarned);
    }
  }
  return payload;
};
